export default "__VITE_ASSET__B3N77jeL__"